import { notification } from "antd";
import { useState } from "react";
import apiMaestras from "../api/Maestras/api-maestras";
import { Categoria, Categorias, LineaConvocatoria } from "../models/Maestras/maestras.model";


export const useModalLineaCategorias = () => {

    const openNotification = ({ titulo, descripcion, placement }: any) => {
        notification.info({
            message: titulo,
            description: descripcion,
            placement,
        });
    };


    const [lineaConvocatoria, setLineaConvocatoria] = useState<LineaConvocatoria>({
        nombre: ''
    })

    const [categoria, setCategoria] = useState<Categoria>({
        nombre: ''
    })

    const [categorias, setCategorias] = useState<Categorias[]>([]);

    const resetCategoria = () => setCategoria({ nombre: '' });


    const addCategoria = () => {
        if (categoria.nombre !== '') {
            setCategorias((prevState: any) => [...prevState, categoria])
        }
        resetCategoria();
    }


    const [openModalExitoso, setOpenModalExitoso] = useState(false);
    const createCategoria = async () => {
        if (lineaConvocatoria.nombre == '') {
            return openNotification({
                titulo: "Error",
                descripcion: "Falta el nombre de la linea",
                placement: "bottomRight",
            });
        }

        if (categorias.length == 0) {
            return openNotification({
                titulo: "Error",
                descripcion: "Falta asociar categorías",
                placement: "bottomRight",
            });
        }

        try {
            const { id } = await apiMaestras.crearLineaConvocatoria(lineaConvocatoria);
            categorias.forEach(async (cat) => {
                let payload: Categorias = {
                    nombre: cat.nombre,
                    linea_convocatoria_id: id
                }
                await apiMaestras.crearCategoriasPorLinea(payload);
            });
            setOpenModalExitoso(true);
        } catch (error) {

        }
    }

    const [visible, setVisible] = useState(false);
    const [datosCategoria, setDatosCategoria] = useState<Categorias>({
        nombre: ''
    });
    const [indexCategoria, setIndexCategoria] = useState(0);
    const editCategoria = (datos: any, index: number) => {
        setDatosCategoria(datos);
        setIndexCategoria(index);
        setVisible(true);
    }

    const [openAlert, setOpenAlert] = useState(false);
    const updateCategoria = () => {
        if (datosCategoria.nombre !== '') {
            let newArray = categorias.map((cat: Categoria, index) => {
                if (index === indexCategoria) {
                    return datosCategoria;
                }

                return cat;
            })

            setCategorias(newArray);
            setVisible(false)
            setOpenAlert(true);
        }
    }

    const deleteCategoria = (index: number) => {
        let newCatgorias = categorias.filter((cat, idx) => idx !== index);
        setCategorias(newCatgorias)
    }



    const getCategoriasLinea = async( id?: number ) => {
        try {
            const { data } = await apiMaestras.obtenerCategoriasPorLinea(id);
            setCategorias(data);
        } catch (error) {
            console.log(error);
        }
    }


    const [cargarCategorias, setCargarCategorias] = useState(false);
    const edicionAsincronaCategoria = async() => {
        try {
            await apiMaestras.actualizarCategoria(datosCategoria);
            setVisible(false)
            setOpenAlert(true);
            setCargarCategorias(true);
            setCargarCategorias(false);
        } catch (error) {
            console.log(error)
        }
    }
    
    const eliminacionAsincronaCategoria = async ( id: number ) => {
        try {
            await apiMaestras.eliminarCategoria(id);
            setCargarCategorias(true);
            setCargarCategorias(false);
        } catch (error) {
            console.log(error)
        }
    }

    return {
        editCategoria,
        deleteCategoria,
        createCategoria,
        lineaConvocatoria,
        setLineaConvocatoria,
        categoria,
        setCategoria,
        addCategoria,
        openAlert,
        datosCategoria,
        setOpenAlert,
        categorias, 
        visible,
        setVisible,
        updateCategoria,
        setDatosCategoria,
        openModalExitoso,
        setOpenModalExitoso,
        getCategoriasLinea,
        edicionAsincronaCategoria,
        cargarCategorias,
        eliminacionAsincronaCategoria,
        openNotification,
        setCategorias
    }
}
